import * as type from './type';
import util from 'common/js/util';

export default {
    [type.GET_LIMIT_RULES](context, option) {
        util.post({
            params: {
                functionId: "queryLimitRule",
                body: JSON.stringify(option.params)
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.DELETE_LIMIT_RULE](context, option){
        util.post({
            params: {
                functionId: "deleteLimitRule",
                body: JSON.stringify(option.params)
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_LIMIT_RULE_DETAIL](context, option){
        util.post({
            params: {
                functionId: "queryLimitRuleDetail",
                body: JSON.stringify(option.params)
            },
            sc(data) {
                context.commit(type.SET_LIMIT_RULE_DETAIL, data.data);
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_WARE_LISTS](context, option){
        util.post({
            params: {
                functionId: "ruleSellerWareList",
                body: JSON.stringify(option.params)
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.ADD_LIMIT_RULE](context, option){
        util.post({
            params: {
                functionId: "addLimitRule",
                body: JSON.stringify(option.params)
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    [type.GET_PROVINCE_LISTS](context, option){
        util.post({
            params: {
                functionId: "provinces"
            },
            sc(data) {
                // 构造区域列表-省列表的数据结构
                // selected: 省是否选中
                // isShowCityList: 省是否展开
                // child: 所属省下的市列表
                data.data.forEach(item => {
                    item.selected = false;
                    item.isShowCityList = false;
                    item.child = [];
                })
                context.commit(type.SET_AREA_LISTS, data.data);
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },


    [type.GET_CITY_LISTS](context, option){
        util.post({
            params:{
                functionId: "city",
                body: JSON.stringify({
                    provinceId: option.params.provinceId.toString()
                })
            },
            sc(data) {
                // 构造区域列表-市列表的数据结构
                // selected: 市是否选中
                data.data.forEach(item => {
                    item.selected = false;
                });
                //拼接区域列表-将返回的数据拼接到所属的省下
                context.state.areaLists.forEach(areaItem => {
                    if(areaItem.id === option.params.provinceId){
                        areaItem.child = data.data;
                    }
                })
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/store/limit-sale/actions.js